import { handleActions, createAction } from "redux-actions";

const START_FULL_PAGE_LOADER = "app/fullPageLoader/START_FULL_PAGE_LOADER";
const STOP_FULL_PAGE_LOADER = "app/fullPageLoader/STOP_FULL_PAGE_LOADER";

export const startFullPageLoader = createAction(
  START_FULL_PAGE_LOADER,
  () => ({})
);

export const stopFullPageLoader = createAction(
  STOP_FULL_PAGE_LOADER,
  () => ({})
);

export const defaultState = {
  loading: false
};

export default handleActions(
  {
    [START_FULL_PAGE_LOADER]: state => ({
      ...state,
      loading: true
    }),
    [STOP_FULL_PAGE_LOADER]: state => ({
      ...state,
      loading: false
    })
  },
  defaultState
);
